var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo-container",attrs:{"to":{ name: 'home' }}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.svg"),"alt":"Słupska Karta Mieszkańca - Strona główna"}})])}
var staticRenderFns = []

export { render, staticRenderFns }